import { Filmomtale } from '@filmweb/sanity-types';
import SMaxWidthContainer from 'components/framework/SMaxWidthContainer';
import { toRem } from 'lib/client/fonts';
import { IMovieArticle } from 'lib/types/sanity';
import styled from 'styled-components';
//#region [Styles]

const SOneliner = styled(SMaxWidthContainer)`
	text-align: center;
	font-size: ${toRem(20)};

	font-weight: var(--font_bold);
	color: white;

	@media screen and (min-width: 641px) {
		margin-top: 50px;
		font-size: ${toRem(40)};
		color: currentColor;
	}
`;

//#endregion

//#region [Props]
type OnelinerProps = {
	document?: IMovieArticle | null;
	filmomtale?: Filmomtale | null;
};
//#endregion

//#region [Component]
export default function Oneliner({ filmomtale, document }: OnelinerProps) {
	const oneliner = document?.oneliner?.trim() ?? filmomtale?.oneliner?.trim();
	if( !oneliner ) {
		return null;
	}
	return <SOneliner $forContent>
		{oneliner}
	</SOneliner>;
}
//#endregion